import { render, staticRenderFns } from "./Quizzort.html?vue&type=template&id=25d56f74&external"
import script from "./Quizzort.js?vue&type=script&lang=js&external"
export * from "./Quizzort.js?vue&type=script&lang=js&external"
import style0 from "./Quizzort.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports